(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('contact-address', {
                parent: 'entity',
                url: '/contact-address',
                data: {
                    authorities: [],
                    pageTitle: 'ContactAddresses'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/contact-address/list/contact-address.html',
                        controller: 'ContactAddressController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_CONTACT_ADDRESS];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CONTACT_ADDRESS, access);
                }]
            });
    }
})();
